import { motion } from "framer-motion";
import { Heart, ArrowRight } from "lucide-react";

export const NonProfit = ({ onSelect }) => {
  return (
    <section id="nonprofit" data-testid="nonprofit-section" className="py-28 sm:py-40 bg-[#0A0A0A]">
      <div className="max-w-[1400px] mx-auto px-6 sm:px-10">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="relative overflow-hidden border border-[#D90429]/40 bg-[#0f0f10] p-10 sm:p-16"
        >
          <div className="absolute -top-16 -right-10 opacity-[0.06]">
            <Heart className="w-72 h-72 text-[#D90429]" />
          </div>
          <div className="relative max-w-2xl">
            <span className="flex items-center gap-2 text-xs uppercase tracking-[0.3em] text-[#EF233C] mb-6">
              <Heart className="w-4 h-4" /> Community
            </span>
            <h2 className="font-head uppercase text-4xl sm:text-6xl tracking-tighter text-white leading-none">
              Free For Non-Profits
            </h2>
            <p className="font-body text-base sm:text-lg text-gray-300 leading-relaxed mt-6">
              Running a registered non-profit? Our graphic design and video editing classes are completely free for
              your team — learn to create your own graphics, websites and edited videos using Canva, CapCut, DaVinci
              Resolve and AI tools. We also offer discounted production for causes that matter.
            </p>
            <button
              data-testid="nonprofit-cta"
              onClick={() => onSelect("class_graphic", true)}
              className="group mt-10 inline-flex items-center gap-4 px-8 py-4 bg-[#D90429] hover:bg-[#EF233C] transition-colors duration-300"
            >
              <span className="font-body uppercase tracking-[0.15em] text-sm text-white">Claim Free Class</span>
              <ArrowRight className="w-4 h-4 text-white group-hover:translate-x-1 transition-transform duration-300" />
            </button>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
